import { render, staticRenderFns } from "./deposits.vue?vue&type=template&id=7f5138fa&scoped=true&"
import script from "./deposits.vue?vue&type=script&lang=js&"
export * from "./deposits.vue?vue&type=script&lang=js&"
import style0 from "./deposits.vue?vue&type=style&index=0&id=7f5138fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5138fa",
  null
  
)

export default component.exports